var map = {
	"./AgendaIcon.vue": 12275,
	"./AlertCircleIcon.vue": 20900,
	"./ArrowRightIcon.vue": 47365,
	"./BugFixIcon.vue": 15331,
	"./CalendarIcon.vue": 55678,
	"./ChevronDownIcon.vue": 36026,
	"./ChevronLeftIcon.vue": 95869,
	"./ChevronRightIcon.vue": 98377,
	"./ChevronUpIcon.vue": 58400,
	"./CircleCheckIcon.vue": 8271,
	"./CircleXIcon.vue": 12200,
	"./DangerSignIcon.vue": 60453,
	"./DashboardIcon.vue": 40771,
	"./DocumentIcon.vue": 93156,
	"./DotsIcon.vue": 41266,
	"./DownloadActiveIcon.vue": 24491,
	"./DownloadIcon.vue": 44939,
	"./EyeIcon.vue": 83570,
	"./EyeOffIcon.vue": 51347,
	"./FileTextIcon.vue": 88184,
	"./FilterIcon.vue": 25452,
	"./FilterUpIcon.vue": 23596,
	"./HandshakeIcon.vue": 73364,
	"./ImprovementsIcon.vue": 93759,
	"./InfoCircleIcon.vue": 79782,
	"./LockIcon.vue": 77779,
	"./MailIcon.vue": 14262,
	"./MaintenanceIcon.vue": 60736,
	"./NewFeatureIcon.vue": 43811,
	"./NotificationsActiveIcon.vue": 11266,
	"./NotificationsIcon.vue": 7486,
	"./PencilIcon.vue": 96746,
	"./PieChartIcon.vue": 78362,
	"./PlusIcon.vue": 54867,
	"./RefreshIcon.vue": 64365,
	"./ReportIcon.vue": 62339,
	"./SearchIcon.vue": 16790,
	"./SettingsIcon.vue": 58691,
	"./StarFullIcon.vue": 37984,
	"./StarIcon.vue": 36684,
	"./SuccessIcon.vue": 35475,
	"./TradeIcon.vue": 81520,
	"./TrainingIcon.vue": 20899,
	"./TrashIcon.vue": 15116,
	"./UpdatesActiveIcon.vue": 4653,
	"./UpdatesIcon.vue": 93273,
	"./UploadIcon.vue": 52795,
	"./UserIcon.vue": 46884,
	"./WalletIcon.vue": 56029,
	"./XIcon.vue": 83587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80421;